module.exports = __webpack_public_path__ + "img/21_DSC8024-min.93e7de22.jpg";